import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="py-3">
          {/* Brand Information */}
          <Col lg={3} md={6} sm={12} className="mb-3">
            <div className="footer-brand">
              <div className="footer-logo">
                <span>M</span>
              </div>
              <h5 className="mt-2">MicroGenie</h5>
            </div>
            <p className="footer-description">Powerful micro-tools for everyday productivity.</p>
          </Col>
          
          {/* Tools Section */}
          <Col lg={3} md={6} sm={6} className="mb-3">
            <h6 className="footer-heading">Productivity Tools</h6>
            <ul className="footer-links">
              <li><Link to="/tools/image-reducer">Image Compressor Pro</Link></li>
              <li><Link to="/tools/resume-templates">Resume Templates</Link></li>
              <li><Link to="/tools/resume-builder">AI Resume Builder</Link></li>
            </ul>
          </Col>
          
          {/* University Section */}
          <Col lg={3} md={6} sm={6} className="mb-3">
            <h6 className="footer-heading">University Resources</h6>
            <ul className="footer-links">
              <li><Link to="/tools/application-forms">Application Forms</Link></li>
              <li><Link to="/tools/fyp-ideas">FYP Project Ideas</Link></li>
              <li><Link to="/tools">All Tools</Link></li>
            </ul>
          </Col>
          
          {/* General Links Section */}
          <Col lg={3} md={6} sm={12} className="mb-3">
            <h6 className="footer-heading">Quick Links</h6>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/tools">Tools</Link></li>
              <li><Link to="/about">About</Link></li>
            </ul>
          </Col>
        </Row>
        
        <hr className="footer-divider my-2" />
        
        <div className="footer-bottom py-2">
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start">
              <p className="copyright mb-0">© 2025 MicroGenie. All rights reserved.</p>
            </Col>
            <Col md={6}>
              <div className="social-links">
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                  <i className="la la-twitter" style={{ fontSize: '16px' }} aria-hidden="true"></i>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <i className="la la-linkedin" style={{ fontSize: '16px' }} aria-hidden="true"></i>
                </a>
                <a href="https://github.com" target="_blank" rel="noopener noreferrer">
                  <i className="la la-github" style={{ fontSize: '16px' }} aria-hidden="true"></i>
                </a>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
